import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/context/LanguageContext";

export default function Faq() {
  const { t } = useLanguage();

  return (
    <section id="faq" className="py-20 bg-slate-50 border-b spec-border" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="mb-12">
          <span className="text-xs font-mono-spec text-gold-600 font-semibold tracking-wider uppercase">{t.faq.eyebrow}</span>
          <h2 className="text-3xl font-bold tracking-tight text-slate-950 mt-2">{t.faq.title}</h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="p-5 bg-white border spec-border rounded-sm"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-bold text-slate-950 text-base text-left hover:no-underline py-0">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 pt-3 leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
